import { JstDate } from '../../core/time/business-time';
import dayjs from 'dayjs';

export function getYearList(currentYear: number): number[] {
  const list: number[] = [];
  for (let i = currentYear - 115; i <= currentYear - 15; i++) list.push(i);
  return list.sort((a, b) => b - a);
}

export function getCcYearList(currentYear: number): string[] {
  const list: string[] = [];
  for (let i = currentYear; i <= currentYear + 10; i++)
    list.push(String(i).slice(-2));
  return list;
}

export function getMonthList(start = 1, end = 12): number[] {
  const list: number[] = [];
  for (let i = start; i <= end; i++) list.push(i);
  return list;
}

export function getDateList(start = 1, end = 31): number[] {
  const list: number[] = [];
  for (let i = start; i <= end; i++) list.push(i);
  return list;
}

export const SEX_LIST = [
  { id: 0, name: 'male' },
  { id: 1, name: 'female' },
];

export const NATIONALITY_LIST = [
  { id: 0, name: 'japan' },
  { id: 1, name: 'otherThanJapan' },
];

export const PAYMENT_METHOD_LIST = [
  { id: 0, name: '口座振替' },
  { id: 1, name: 'クレジットカード' },
];

export const RELATIONSHIP_LIST = [
  { id: 0, name: 'wife' },
  { id: 1, name: 'husband' },
  { id: 2, name: 'father' },
  { id: 3, name: 'mother' },
  { id: 4, name: 'child' },
  { id: 5, name: 'sibling' },
  { id: 6, name: 'other' },
];

export function getDesiredStartDateList(dateArr: string[], weekday: number): Array<{ id: string; name: string }> {
  const weekdayList = '日月火水木金土';
  const lastDay = new JstDate(Number(dateArr[0]), Number(dateArr[1]), 0).getDate();
  const today = Number(dateArr[2]);
  const hour = Number(dateArr[3]);
  const modify = hour >= 21 ? 1 : 0;
  weekday += modify;
  const list: Array<{ id: string; name: string }> = [];
  for (let i = today + modify; i <= lastDay; i++) {
    list.push({
      id: `${dateArr[0]}-${String(dateArr[1]).padStart(2, '0')}-${String(i).padStart(2, '0')}`,
      name: `${dateArr[0]}年${dateArr[1]}月${i}日 (${weekdayList[weekday % 7]})`,
    });
    weekday++;
  }
  return list;
}

export function studioDisplay(local: any, numberOrStudios: any): boolean {
  if (Array.isArray(numberOrStudios)) {
    return numberOrStudios.some((s: any) => s.localNumber === local.localNumber);
  }
  return local.localNumber === numberOrStudios;
}

function capitalize(str: string): string {
  if (str === 'ja') return '';
  if (!str) return str;
  if (str.includes('-')) {
    const parts = str.split('-');
    return parts[0].charAt(0).toUpperCase() + parts[0].slice(1).toLowerCase() + parts[1];
  }
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

export function collectOptions(data: any[], lang = 'ja'): Record<number, any> {
  if (!data.length) return {};
  const questionarys: Record<number, any> = {};
  let questionary: any = {};
  let selectColumns: any = {};
  let selectColumn: any = {};
  let questionaryGroupId = 0;
  let dataCount = 1;
  let isFirst = true;

  for (const val of data) {
    const groupId = parseInt(val['questionaryGroupId']);
    if (isFirst) {
      setQuestionary(val);
      isFirst = false;
    } else if (questionaryGroupId !== groupId) {
      setQuestionarys();
      dataCount++;
      questionary = {};
      selectColumns = {};
      setQuestionary(val);
    } else {
      setSelectColumns(val);
    }
  }
  setQuestionarys();
  return questionarys;

  function setQuestionary(val: any) {
    const cap = capitalize(lang);
    questionary = {
      questionaryContent: val[`questionaryContent${cap}`] || val['questionaryContent'],
      questionaryGroupId: val['questionaryGroupId'],
      freeFlg: val['freeFlg'],
      isMultiSelect: val['isMultiSelect'],
    };
    setSelectColumns(val);
  }

  function setSelectColumns(val: any) {
    const cap = capitalize(lang);
    selectColumn = {
      id: val['id'],
      inputMemoFlg: val['inputMemoFlg'],
      inputMemoContent: val['inputMemoContent'],
      name: val[`selectColumn${cap}`] || val['selectColumn'],
    };
    const idx = Object.keys(selectColumns).length;
    selectColumns[idx] = selectColumn;
    questionaryGroupId = val['questionaryGroupId'];
  }

  function setQuestionarys() {
    questionary['scopeName'] = dataCount;
    questionary['selectColumns'] = selectColumns;
    normalizeQuestionary(questionary);
    questionarys[questionaryGroupId] = questionary;
  }
}

export function normalizeQuestionaries(questionarys: Record<string | number, any> | undefined): void {
  if (!questionarys) return;
  for (const questionary of Object.values(questionarys)) {
    normalizeQuestionary(questionary);
  }
}

function normalizeQuestionary(questionary: any): void {
  if (!questionary?.selectColumns) return;

  if (questionary.isMultiSelect === 1 && !questionary.check) {
    questionary.check = {};
  }

  if (
    questionary.isMultiSelect === 1 &&
    Array.isArray(questionary.selectColumns.value)
  ) {
    for (const id of questionary.selectColumns.value) {
      questionary.check[id] = true;
    }
    questionary.selectColumns.hasCheck = questionary.selectColumns.value.length > 0 ? true : undefined;
  }

  if (
    questionary.freeFlg === 1 &&
    questionary.selectColumns.value === undefined
  ) {
    questionary.selectColumns.value = firstSelectColumnId(questionary.selectColumns);
  }
}

function firstSelectColumnId(selectColumns: any): number | string | undefined {
  for (const key of Object.keys(selectColumns)) {
    if (isNaN(Number(key))) continue;
    return selectColumns[key]?.id;
  }
  return undefined;
}

export function getInputMemoFlg(columns: any, id: number): boolean {
  for (const key of Object.keys(columns)) {
    if (isNaN(Number(key))) continue;
    const el = columns[key];
    if (String(el.id) === String(id) && el.inputMemoFlg === 1) return true;
  }
  return false;
}

export function createQuestionaryResult(member: any): any[] {
  const questionarys = member.tmp?.questionarys;
  if (!questionarys) return [];
  normalizeQuestionaries(questionarys);
  const results: any[] = [];
  for (const q of Object.values(questionarys) as any[]) {
    const value = q.selectColumns?.value ?? (q.freeFlg === 1 ? firstSelectColumnId(q.selectColumns) : undefined);
    if (Array.isArray(value)) {
      for (const id of value) {
        results.push(buildResult(member, q, id));
      }
    } else {
      results.push(buildResult(member, q, value));
    }
  }
  return results;
}

function buildResult(member: any, questionary: any, id: any) {
  const inputMemoFlg = getInputMemoFlg(questionary.selectColumns, id);
  const inputMemo =
    questionary.selectColumns.inputMemo !== undefined &&
    (questionary.freeFlg || inputMemoFlg)
      ? questionary.selectColumns.inputMemo
      : null;
  return {
    questionaryMasterId: id,
    studioId: member.studioId,
    studioPlanId: member.studioPlanId,
    memberId: null,
    inputMemoResult: inputMemo,
  };
}

export function getSelectColumnName(selectColumns: any): string {
  const value = selectColumns.value;
  let name = '';
  for (const key of Object.keys(selectColumns)) {
    if (key === 'value' || key === 'inputMemo') continue;
    const el = selectColumns[key];
    if (Array.isArray(value)) {
      for (const v of value) {
        if (String(el.id) === String(v)) {
          name = name ? name + '、 ' + el.name : el.name;
        }
      }
    } else {
      if (String(el.id) === String(value)) name = el.name;
    }
  }
  return name;
}

export function isEligibleAge(year: number, month: number, day: number): boolean {
  if (!year || !month || !day) return true;
  const target = new JstDate(year + '/' + month + '/' + day);
  const now = new JstDate();
  const eligibleYear = now < new JstDate(now.getFullYear() + '/04/02') ? 19 : 18;
  return target < new JstDate((now.getFullYear() - eligibleYear) + '/04/02');
}
